import { render } from "./CertificateBanner.vue?vue&type=template&id=0cc9473e&scoped=true"
import script from "./CertificateBanner.vue?vue&type=script&lang=js"
export * from "./CertificateBanner.vue?vue&type=script&lang=js"

import "./CertificateBanner.vue?vue&type=style&index=0&id=0cc9473e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cc9473e"]])

export default __exports__